import React, {FC, useContext, useEffect, useState} from 'react';
import { Typography } from "antd";

import { ISeller } from "interfaces";
import {StoreContext} from '../../contexts/StoreContext';
import {UtilityHelper} from '../../helper/utility';
import {API_URL} from '../../constants';
import {useGetIdentity, useOne} from '@refinedev/core';
import {ColorModeContext} from '../../contexts';
const { Text } = Typography;
interface SelectProps {
    onSelect: () => void;
    theme?: "light" | "dark";
};

export const StoreSelect: FC<SelectProps> = ( props ) => {
    const {value, value2, value3, value4} = useContext(StoreContext);
    const [store, setStore] = value;
    const [userPermission, setUserPermission] = value2;
    const [autoTurn, setAutoTurn] = value3;
    const [espositore, setEspositore] = value4;
    const { data: userIdentity } = useGetIdentity<any>();
    const mode = useContext(ColorModeContext);
    const utilityHelper = UtilityHelper(API_URL + "/api");
    const [descrizioneEspositore, setDescrizioneEspositore] = useState('');

    useEffect(() => {
        utilityHelper.seller().then( (r: any) => {
            setStore(r);
        });
        utilityHelper.userIdEspositore().then( (r: any) => {
            setEspositore(r);
        });
        utilityHelper.userEspositore().then( (r: any) => {
            setDescrizioneEspositore(r);
        });
        utilityHelper.permission().then( (u: any) => {
            setUserPermission(u);
        });
        utilityHelper.getAutoTurn().then( (a: any) => {
            // console.log(a.autoTurn);
            setAutoTurn(a.autoTurn ? a.autoTurn : false);
        });
    }, []);

    return (
        <Text style={{ color: props.theme === 'light' ? 'black' : 'whitesmoke'}}>{(userIdentity?.username)} - Espositore: {descrizioneEspositore}</Text>
    );
};
